<template>
  <div>
    <HeroSection />
    <DiscoverProperties />
    <FeaturedProperties />
    <WhyChooseUs />
    <!-- <StatsSection /> -->
    <ReviewsSection />
    <BlogSection />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { setSeo } from '@/utils/seo'
import HeroSection from '@/components/HeroSection.vue'
import DiscoverProperties from '@/components/DiscoverProperties.vue'
import FeaturedProperties from '@/components/FeaturedProperties.vue'
import WhyChooseUs from '@/components/WhyChooseUs.vue'
import StatsSection from '@/components/StatsSection.vue'
import ReviewsSection from '@/components/ReviewsSection.vue'
import BlogSection from '@/components/BlogSection.vue'

@Options({
  components: {
    HeroSection,
    DiscoverProperties,
    FeaturedProperties,
    WhyChooseUs,
    StatsSection,
    ReviewsSection,
    BlogSection
  }
})
export default class HomeView extends Vue {
  mounted () {
    setSeo({
      title: "Rwanda's Premier Property Platform",
      description: 'Find houses, apartments, and land for sale and rent across Rwanda. Browse verified listings from trusted real estate agents in Kigali, Gasabo, Nyarugenge, and beyond.',
      keywords: 'Rwanda real estate, property Rwanda, houses for sale Kigali, apartments for rent Kigali, land for sale Rwanda, real estate agents Kigali'
    })
  }
}
</script>
